import { render, staticRenderFns } from "./ConfigTabTelaDescanso.vue?vue&type=template&id=0f9e48d3&scoped=true"
import script from "./ConfigTabTelaDescanso.vue?vue&type=script&lang=js"
export * from "./ConfigTabTelaDescanso.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabTelaDescanso.vue?vue&type=style&index=0&id=0f9e48d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e48d3",
  null
  
)

export default component.exports